
import { defineComponent, reactive, toRefs,ref } from 'vue';

export default defineComponent({
  props:{
    replyList: {
      type: Array,
      default:() =>[]
    }},
  setup() {
   // const replyList = reactive([{title:'人脸识别出现错误，请帮忙',replyContent:'人脸识别不支持微信',count:999},{title:'人脸识别出现错误，请帮忙',replyContent:'人脸识别不支持微信',count:999},{title:'人脸识别出现错误，请帮忙',replyContent:'人脸识别不支持微信',count:999},{title:'人脸识别出现错误，请帮忙',replyContent:'人脸识别不支持微信',count:999},{title:'人脸识别出现错误，请帮忙',replyContent:'人脸识别不支持微信',count:999},{title:'人脸识别出现错误，请帮忙',replyContent:'人脸识别不支持微信',count:999},{title:'人脸识别出现错误，请帮忙',replyContent:'人脸识别不支持微信',count:999},{title:'人脸识别出现错误，请帮忙',replyContent:'人脸识别不支持微信',count:999}]);
    return{
      //replyList,
    }
  },
})
